import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';

const ReportGraph = () => {
  const option = {
    color: ['#FF69B4', '#87CEEB', '#87CEFA', '#00BFFF', '#1E90FF'],
    title: {
      text: 'Highly Selective',
      textStyle: {
        fontSize: 23,
        fontWeight: 'bold',
        fontFamily: 'sans-serif'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br /> {b}'
    },
    legend: {
      data: ['All', 'Good', 'Great', 'Best', 'Top Rated'],
      orient: 'vertical',
      right: 'right'
    },
    series: [
      {
        name: 'Hospitals',
        type: 'funnel',
        top: '20%',
        left: '5%',
        width: '80%',
        height: '70%',
        minSize: '0%',
        maxSize: '70%',
        sort: 'ascending',
        gap: 6,
        label: {
          normal: {
            formatter: '{b}'
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        itemStyle: {
          normal: {
            borderColor: 'fff',
            borderWidth: 0,
            shadowBlur: 50,
            shadowOffsetX: 0,
            shadowOffsetY: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        data: [
          { value: 20, name: 'Top Rated: 0.098%' },
          { value: 40, name: 'Best: 0.393%' },
          { value: 60, name: 'Great: 6.547%' },
          { value: 80, name: 'Good: 21.276%' },
          { value: 100, name: 'All: 100%' }
        ]
      }
    ]
  };
  const instance = useRef(null);

  return <ReactECharts ref={instance} option={option} />;
};

export default ReportGraph;



// WEBPACK FOOTER //
// ./src/components/ReportGraph/ReportGraph.js